class VerticalFeaturedContentComponentLatest {

    constructor(el) {
        this.el = el;
        this.init();
    }

    init() {
        this.initLoadMoreVariables();
        this.verticalLoadMorePosts();
    }

    initLoadMoreVariables() {
        const loadMoreButton = $(this.el).find('.vertical-load-more-posts');
        this.loadMoreItems = loadMoreButton.data('items');
        this.loadMoreVertical = loadMoreButton.data('vertical');
        this.loadMoreExclude = loadMoreButton.data('exclude');
        this.loadMorePage = loadMoreButton.data('page');
    }

    verticalLoadMorePosts = () => {
        const loadMoreButton = $(this.el).find('.vertical-load-more-posts');
        loadMoreButton.on('click', (e) => {
            e.preventDefault();
            this.loadPosts();
        });
    };

    loadPosts = () => {
        const loadMoreButton = $(this.el).find('.vertical-load-more-posts');

        $.ajax({
            type: 'post',
            dataType: 'json',
            url: wp_ajax.ajaxurl,
            data: {
                action: 'vertical_load_more_posts',
                page: this.loadMorePage,
                items: this.loadMoreItems,
                vertical: this.loadMoreVertical,
                exclude: this.loadMoreExclude,
            },
            success: (result) => {
                this.handleLoadPostsSuccess(result, loadMoreButton);
            },
            error: function (result) {
                console.log(JSON.stringify(result));
            },
        });
    };

    handleLoadPostsSuccess = (result, loadMoreButton) => {
        if (result.status === 'success') {
            let html = '';
            if (result.posts.length) {
                result.posts.map(item => {
                    switch (this.loadMoreVertical) {
                        case 'txo':
                            html += this.generateTxoItemHtml(item);
                            break;
                        default:
                            html += this.generateItemHtml(item);
                    }
                });
            }

            const postList = loadMoreButton.parents('.featured-content-list').find('ul');
            postList.append(html);
        }

        if (result.isLast || result.posts.length < this.loadMoreItems) {
            loadMoreButton.hide();
        } else {
            this.loadMorePage += 1;
        }
    };

    generateTxoItemHtml = (item) => {
        return `
            <li>
                <h6>
                    <a href="${item.permalink}">${item.title}</a>${item.tags}
                </h6>
                <div class="speaker-listener">
                    ${item.authors}
                </div>
                <div class="txt">
                    <p>${item.excerpt}</p>
                </div>
            </li>
        `;
    };

    generateItemHtml = (item) => {
        return `
            <li>
                <h4>
                    <a href="${item.permalink}">${item.title}</a>${item.tags}
                </h4>
                <div class="post-meta">
                    <div class="author">${item.authors}</div>
                </div>
                <div class="txt">
                    <p>${item.excerpt}</p>
                </div>
            </li>
        `;
    };
}

export default VerticalFeaturedContentComponentLatest;
